export  const environment = {
  production: true,
  platformNameOrchGT: 'Mindx Live', //Production
  apiUrl: 'https://intxg.app/api/',
  apiUrlNewBack: 'https://intxg.app/api/',
  mindxbkUrl: 'https://mdxlivebk.app/api/',
  wssUrl: 'wss://mdxlivebk.app/api/',

  turnstile:{
    siteKey: '0x4AAAAAAButD6SHKPZeExkF', //prod
  }
};
